import { NavSchema } from './Nav.styles';

export const navStyles: NavSchema = {
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    bg: 'alpha.700',
    w: ['100% + 8px', null, '100%'],
    boxShadow:
      '0px 1px 5px 0px rgba(0, 0, 0, 0.25), 0px 1px 0px 0px rgba(255, 255, 255, 0.10)',
    borderRadius: ['none', null, 'lg'],
    minH: '9',
    h: 'auto',
    px: '4',
    mx: ['-2', null, '0'],
    my: '3',
  },
  link: {
    boxShadow: 'none',
    textTransform: 'uppercase',
    border: 'none',
    fontWeight: 'bold',
    fontSize: 'xs',
    textShadow: 'none',
    lineHeight: '1.7',
    borderRadius: 'none',
    h: '10',
    color: 'white',
    borderBottom: '3px solid',
    borderBottomColor: 'transparent',
    px: '3',
    pt: '2',
    pb: '1',
    _hover: {
      textDecoration: 'none',
    },
    sx: {
      '&.active': {
        color: 'beta.400',
        border: 'none',
        borderBottom: '3px solid',
        borderBottomColor: 'beta.400',
      },
    },
  },
};
